export default __webpack_public_path__ + "static/media/H0001.a0a94d87.png";